var _excluded = ["htmlWidth", "htmlHeight", "alt"],
  _excluded2 = ["fallbackSrc", "fallback", "src", "align", "fit", "loading", "ignoreFallback", "crossOrigin"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import { tqc, forwardRef } from '../../system';
import { omit, __DEV__ } from '../../utils';
import * as React from 'react';
import { useImage } from './use-image';
var NativeImage = /*#__PURE__*/React.forwardRef((props, ref) => {
  var {
      htmlWidth,
      htmlHeight,
      alt
    } = props,
    rest = _objectWithoutProperties(props, _excluded);
  return /*#__PURE__*/React.createElement("img", _extends({
    width: htmlWidth,
    height: htmlHeight,
    ref: ref,
    alt: alt
  }, rest));
});
if (__DEV__) {
  NativeImage.displayName = 'NativeImage';
}
/**
 * React component that renders an image with support
 * for fallbacks
 */
export var Image = forwardRef((props, ref) => {
  var {
      fallbackSrc,
      fallback,
      src,
      align,
      fit,
      loading,
      ignoreFallback,
      crossOrigin
    } = props,
    rest = _objectWithoutProperties(props, _excluded2);

  /**
   * Defer to native `img` tag if `loading` prop is passed
   */
  var shouldIgnore = loading != null || ignoreFallback;
  var status = useImage(_objectSpread(_objectSpread({}, props), {}, {
    ignoreFallback: shouldIgnore
  }));
  var shared = _objectSpread({
    ref,
    objectFit: fit,
    objectPosition: align
  }, shouldIgnore ? rest : omit(rest, ['onError', 'onLoad']));
  if (status !== 'loaded') {
    /**
     * If user passed a custom fallback component,
     * let's render it here.
     */
    if (fallback) return fallback;
    return /*#__PURE__*/React.createElement(tqc.img, _extends({
      as: NativeImage,
      className: "tqc-image__placeholder",
      src: fallbackSrc
    }, shared));
  }
  return /*#__PURE__*/React.createElement(tqc.img, _extends({
    as: NativeImage,
    src: src,
    crossOrigin: crossOrigin,
    loading: loading,
    className: "tqc-image"
  }, shared));
});
/**
 * Fallback component for most SSR users who want to use the native `img` with
 * support for tqc props
 */
export var Img = forwardRef((props, ref) => /*#__PURE__*/React.createElement(tqc.img, _extends({
  ref: ref,
  as: NativeImage,
  className: "tqc-image"
}, props)));
if (__DEV__) {
  Image.displayName = 'Image';
}